import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialerModule } from 'dialer';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgPipesModule } from 'ngx-pipes';
import { BuildingModule } from '../building/building.module';
import { OneSourceModule } from '../one-source/one-source.module'
import { CoreModule } from '../core/core.module';
import { DialerClientModule } from '../dialer-client/dialer-client.module';
import { PathTestModule } from '../path-test/path-test.module';
import { PathModule } from '../path/path.module';
import { PointModule } from '../point/point.module';
import { PostProcessingModule } from '../post-processing/post-processing.module';
import { ScoutModule } from '../scout/scout.module';
import { SharedModule } from '../shared/shared.module';
import { StatusBarComponent } from '../status-bar/status-bar.component';
import { TaskModule } from '../task/task.module';
import { UserModule } from '../user/user.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeTabComponent } from './home-tab/home-tab.component';
import { HomeComponent } from './home.component';
import { FormsModule } from '@angular/forms';
import { ReactiveComponentModule } from '@ngrx/component';
import { VolunteerModule} from "../volunteer/volunteer.module";
import { EventLogModule } from "../event-log/event-log.module";


@NgModule({
  declarations: [HomeComponent,HomeTabComponent,StatusBarComponent],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    FormsModule,
    DialerModule,
    HomeRoutingModule,
    TaskModule,
    UserModule,
    PathTestModule,
    PathModule,
    BuildingModule,
    OneSourceModule,
    PointModule,
    ScoutModule,
    PostProcessingModule,
    DialerClientModule,
    VolunteerModule,
    EventLogModule,
    NgPipesModule,
    ReactiveComponentModule,
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot()
  ]
})
export class HomeModule {}
